import { Uuid } from "../../domain/model/uuid/uuid.type";
import { PigGenderViewModel } from "../shared/pig-gender.viewmodel";
import { SectionOverviewBatchRowWeighingViewModel } from "./section-overview-batch-row-weighing.viewmodel";

export class SectionOverviewBatchRowViewModel {

  constructor(
    readonly sectionId: Uuid,
    readonly trialId: Uuid,
    readonly batchId: Uuid,
    readonly batchNumber: number,
    readonly gender: PigGenderViewModel,
    readonly weighings: SectionOverviewBatchRowWeighingViewModel[],
  ) { }

  getMaxInterimNumber(): number {
    const interims = this.weighings
    .filter(weighing => !weighing.isInitial() && !weighing.isFinal());
    if (interims.length === 0) {
      return 0;
    }
    return Math.max(...interims.map(weighing => weighing.interimSequenceNumber ?? 0));
  }

  hasMultipleInterim(): boolean {
    return this.weighings
      .filter(weighing => !weighing.isInitial() && !weighing.isFinal()).length > 0;
  }

  getInterimOrdered(): SectionOverviewBatchRowWeighingViewModel[] {
    return this.weighings
    .filter(weighing => !weighing.isInitial() && !weighing.isFinal())
    .sort((a, b) => (a.interimSequenceNumber ?? 0) - (b.interimSequenceNumber ?? 0));
  }

  getInterimByOrder(order: number): SectionOverviewBatchRowWeighingViewModel | null {
    return this.weighings
      .filter(weighing => !weighing.isInitial() && !weighing.isFinal())
      .find(weighing => weighing.interimSequenceNumber === order) || null;
  }

  getInitial(): SectionOverviewBatchRowWeighingViewModel | null {
    return this.weighings.find(weighing => weighing.isInitial()) || null;
  }

  getFinal(): SectionOverviewBatchRowWeighingViewModel | null {
    return this.weighings.find(weighing => weighing.isFinal()) || null;
  }

  isInitial(): boolean { // emhe: udkast - er det rigtigt?
    return this.weighings.some(weighing => weighing.isInitial());
  }

  isFinal(): boolean {// emhe: udkast - er det rigtigt?
    return this.weighings.some(weighing => weighing.isFinal());
  }

  toString(): string {
    return `SectionOverviewBatchRowViewModel: BatchWeighingId: ${this.batchNumber},
     Section: ${this.sectionId},
      TrialId: ${this.trialId}`;
  }
}
